"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var utils_1 = require("../utils");
function useTrackEntry(_a) {
    var _b = _a === void 0 ? {
        track: function () { },
    } : _a, track = _b.track, trackingMessage = _b.trackingMessage, trackingProps = _b.trackingProps;
    function trackEntry() {
        if (utils_1.isBrowser()) {
            var message = trackingMessage || 'track entry';
            track(message, __assign({}, trackingProps));
        }
    }
    var trackEntryCallback = react_1.useCallback(trackEntry, []);
    react_1.useEffect(trackEntryCallback, [trackEntryCallback]);
}
exports.default = useTrackEntry;
